import React from "react";
import { ChevronDown } from "lucide-react";

const Select = React.forwardRef(({ className = "", children, error, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={`h-12 w-full appearance-none rounded-xl border-[1px] bg-white dark:bg-ink-900 px-4 text-[14px] font-medium text-ink-900 dark:text-ink-100
        focus:outline-none focus:ring-[3px] focus:ring-brand-500/15 focus:border-brand-500 transition-all duration-200
        ${error ? "border-red-400 dark:border-red-500" : "border-ink-200 dark:border-ink-700 hover:border-ink-300 dark:hover:border-ink-600"} ${className}`}
      style={{ paddingRight: "2.5rem" }}
      {...props}
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400 dark:text-ink-500" />
  </div>
));

export default Select;

